import "./App.scss";
import AppRouter from "./routes/AppRouter";
import { useAuthMeQuery } from "./store/services/auth-api";
import { getUserCountry } from "./utils/getUserCountry";
import Clarity from "@microsoft/clarity";

function App() {
  const projectId = "rba7w4340y";

  Clarity.init(projectId);
  getUserCountry();
  const token = localStorage.getItem("accessToken");
  const { error, isLoading } = useAuthMeQuery(null, {
    skip: !token,
  });

  if (isLoading) return <h1>Loading...</h1>;
  if (error) return <h1>Error occurred while fetching</h1>;

  return <AppRouter />;
}

export default App;
